export default __webpack_public_path__ + "locales/nl/VersionHistory.json?hash=401fa206a6647f468b3d7ed10827a95c";